import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FontSize = 'small' | 'medium' | 'large' | 'xl' | 'xxl';
export type DateFormat = 'DD/MM/YYYY' | 'MM/DD/YYYY' | 'YYYY-MM-DD';
export type TimeFormat = '12h' | '24h';
export type NumberFormat = 'en-US' | 'de-DE' | 'en-IN';

export interface UserConfigState {
  fontSize: FontSize;
  dateFormat: DateFormat;
  timeFormat: TimeFormat;
  numberFormat: NumberFormat;
}

const initialState: UserConfigState = {
  fontSize: 'medium',
  dateFormat: 'DD/MM/YYYY',
  timeFormat: '12h',
  numberFormat: 'en-US',
};

const userConfigSlice = createSlice({
  name: 'userConfig',
  initialState,
  reducers: {
    setUserConfig: (state, action: PayloadAction<Partial<UserConfigState>>) => {
      return { ...state, ...action.payload };
    },
    setFontSize: (state, action: PayloadAction<FontSize>) => {
      state.fontSize = action.payload;
    },
    setDateFormat: (state, action: PayloadAction<DateFormat>) => {
      state.dateFormat = action.payload;
    },
    setTimeFormat: (state, action: PayloadAction<TimeFormat>) => {
      state.timeFormat = action.payload;
    },
    setNumberFormat: (state, action: PayloadAction<NumberFormat>) => {
      state.numberFormat = action.payload;
    },
  },
});

export const {
  setUserConfig,
  setFontSize,
  setDateFormat,
  setTimeFormat,
  setNumberFormat,
} = userConfigSlice.actions;

export default userConfigSlice.reducer;
